// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toggle {
  font-weight: 600;
  --track-background-checked: #ed143d;
}

ion-label {
  white-space: normal !important;
}
ion-label h2 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
}
ion-label p {
  font-size: 14px;
  color: var(--ion-color-medium);
  margin-top: 4px;
  white-space: normal;
  overflow: visible;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/booking-visibility-preferences-modal/booking-visibility-preferences-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,mCAAA;AACF;;AAEA;EACE,8BAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AAEE;EACE,eAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAAJ","sourcesContent":["ion-toggle {\n  font-weight: 600;\n  --track-background-checked: #ed143d;\n}\n\nion-label {\n  white-space: normal !important;\n\n  h2 {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 4px;\n  }\n\n  p {\n    font-size: 14px;\n    color: var(--ion-color-medium);\n    margin-top: 4px;\n    white-space: normal;\n    overflow: visible;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
